import { Fragment, useState } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputText from "../../helpers/InputText";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";

import back from "../../back.png";
import XDateFee from "./XDateFee";
import XTime from "./XTime";
import FormatDecimal from "../../helpers/FormatDecimal";


function Start(props)
{

    var dt = new Date();

    const [errTab, setErrTab] = useState([]);  //z info od serwera..


  

    const [row, setRowX] = useState({
        p_dziecko_id: -1,
        fraza:  "",          
        profil:  null,  
        
        imie: '',
        nazwisko: '',
        p_grupa_id: '_x_',

        miesiac: dt.getMonth()+1,
        rok: dt.getFullYear(),

        p_typy_oplat_id: '_x_',

    });
    var tmpRow = row;



    
    const [goAllRefresh, setGoAllRefresh] = useState(0);

    const [tabKalendar, setTabKalendarz] = useState(null);
    const [tabNieobecnosci, setTabNieobecnosci] = useState(null);
    const [tabGodziny, setTabGodziny] = useState(null);
    const [tabNadGodziny, setTabNadGodziny] = useState(null);
    const [tabWejsciaWyjscia, setTabWejsciaWyjscia] = useState(null);
    const [tabStawki, setStawki] = useState(null);



    var dt = new Date();
    const [showDay, setShowDay] = useState({
        from: dt.getDate() - 3,
        to: dt.getDate() + 3,
    });
    const [strToDay, setStrToDate] = useState( dt.toISOString().split`T`[0]  ); 



    const [lata, setLata] = useState(null);
    const [miesiace, setMiesiace] = useState(null);


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
        
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRowX(  JSON.parse(JSON.stringify(tmpRow)) );    
    
        setGoAllRefresh(1);
     
    }   


    const goNextNew = () => {
        console.log("goNext");
      //  saveData();
    }



    const getLata = () => {
       
 
        var y = new Array();

 
       

        var dt = new Date();

        var next = dt.getFullYear()+1;
        y.push({
            v: next,
            title: next
        }); 


        for(var k=dt.getFullYear(); k>2011; k--)
            {
                y.push({
                    v: k,
                    title: k
                }); 
            }

        setLata(y);      
 
    }


    const getMiesiace = () => {
       
 
        var y = new Array();
 

        y.push({
            v: '01',
            title: 'Styczeń'
        });


        y.push({
            v: '02',
            title: 'Luty'
        });

        y.push({
            v: '03',
            title: 'Marzec'
        });

        y.push({
            v: '04',
            title: 'Kwiecień'
        });


        y.push({
            v: '05',
            title: 'Maj'
        });

        y.push({
            v: '06',
            title: 'Czerwiec'
        });

        y.push({
            v: '07',
            title: 'Lipiec'
        });

        y.push({
            v: '08',
            title: 'Sierpień'
        });


        y.push({
            v: '09',
            title: 'Wrzesień'
        });

        y.push({
            v: '10',
            title: 'Październik'
        });

        y.push({
            v: '11',
            title: 'Listopad'
        });

        y.push({
            v: '12',
            title: 'Grudzień'
        });

        setMiesiace(y);      
 
    }




    const getProfile = (id) => {
       
 
        props.mainView.setProgress(-2);


        var req = {
            id: id
        }

        fetch( Config.url + '/rest_v1_kids,profile', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       setRowX({ ...row, ["profil"]: res.result }) ;                     
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const getAll = (id) => {


        var tmpId = row.p_dziecko_id;

        if(id != undefined && id != null && id > 0) tmpId = id;

        getCal();
        getTabNieObecnosci(tmpId);
        getTabGodziny(tmpId);
        getTabNadgodziny(tmpId);
        getTabWejsciaWyjscia(tmpId);
        getStawki(tmpId);
    }


    //pobiera kalendarz z okreslenie dni / wolnie sb nd itd..
    const getCal = () => {
       
 
    

        props.mainView.setProgress(-2);       

        fetch( Config.url + '/rest_v1_kids,calendar', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTabKalendarz(res.result);                           
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const getTabNieObecnosci = (id) => {
       
 
        var t = row;
        if(id != undefined && id != null && id > 0)  t["p_dziecko_id"] = id;

        props.mainView.setProgress(-2);       

        fetch( Config.url + '/rest_v1_kids,free', {
            method: 'POST', 
            body: JSON.stringify(t), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTabNieobecnosci(res.result);                           
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const getTabGodziny = (id) => {
       
 
        props.mainView.setProgress(-2);


        var t = row;
        if(id != undefined && id != null && id > 0)  t["p_dziecko_id"] = id;
       

        fetch( Config.url + '/rest_v1_kids,hour_v', {
            method: 'POST', 
            body: JSON.stringify(t), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTabGodziny(res.result);            
                              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    const getTabNadgodziny = (id) => {
       
 
        props.mainView.setProgress(-2);

        var t = row;
        if(id != undefined && id != null && id > 0)  t["p_dziecko_id"] = id;

       

        fetch( Config.url + '/rest_v1_kids,over_v', {
            method: 'POST', 
            body: JSON.stringify(t), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTabNadGodziny(res.result);            
                                  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const getTabWejsciaWyjscia = (id) => {
       
 
        props.mainView.setProgress(-2);


        var t = row;
        if(id != undefined && id != null && id > 0)  t["p_dziecko_id"] = id;
       

        fetch( Config.url + '/rest_v1_kids,inout_v', {
            method: 'POST', 
            body: JSON.stringify(t), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTabWejsciaWyjscia(res.result);                               
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const getStawki = (id) => {
       
 
        props.mainView.setProgress(-2);


        var t = row;
        if(id != undefined && id != null && id > 0)  t["p_dziecko_id"] = id;
       

        fetch( Config.url + '/rest_v1_kids,hour_over_st', {
            method: 'POST', 
            body: JSON.stringify(t), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setStawki(res.result);                               
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }







    const zmienStatus = (e) => {
       

        //dzien={dd.dzien} p_typy_oplat_id={dd.p_typy_oplat_id}  p_dziecko_id={dd.p_dziecko_id} 


        var dzien = e.target.getAttribute('dzien');
        var p_typy_oplat_id = e.target.getAttribute('p_typy_oplat_id');
        var p_dziecko_id = e.target.getAttribute('p_dziecko_id');


        var req = {
            dzien: dzien,
            p_typy_oplat_id: p_typy_oplat_id,
            p_dziecko_id: p_dziecko_id, 
        };

     
      
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,free_change', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       getAll();          
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }





    const kidSelected = (id) => {
        console.log("Kid ", id);
     

        setRowX({...row, ["p_dziecko_id"]:id  });

        if(id == -1) return;
        
        getProfile(id)     
        getAll(id);
        
        
    }

    const onBack = () => {


        if(props.onBack != undefined && props.onBack != null)
        {
            props.onBack();
            return;
        }

        setRowX( {...row, ["id"]:-1, ["fraza"]: "", ["profil"]: null   }  ); 
    }


    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
       // setRowX({...row, ["id"]:-1,["fraza"]:'', ["profil"]:null  });

        setRowX(
            {
                p_dziecko_id: "-1",
                fraza:  "",          
                profil:  null,  
                
                imie: '',
                nazwisko: '',
                p_grupa_id: '_x_',
        
                miesiac: dt.getMonth()+1,
                rok: dt.getFullYear(),
        
                p_typy_oplat_id: '_x_',
        
            }
        );
    }


    if(lata == null)  {
        getLata();
    }


    if(miesiace == null)  {
        getMiesiace();
    }



    if(props.p_dziecko_id != undefined && props.p_dziecko_id != null && row.p_dziecko_id != props.p_dziecko_id ) 
    {
        setRowX({...row, ["p_dziecko_id"]:props.p_dziecko_id  });
        getProfile(props.p_dziecko_id)     
        getAll(props.p_dziecko_id);          
    }

    if(props.p_dziecko_id != undefined && props.p_dziecko_id != null   && row.profil == null ) 
    {
                return <div>
                   czekaj...
            </div>    
    }


        if(row.profil == null)
        {
            document.title = "Szukaj: " + row.fraza;


            return <div className="view_content">

                          

                            <form className="eForm bg_center">

                                        <div className="form_tab">

                                                    <div className="form_control">
                                                        <div className="fieldName">Imię i nazwisko dziecka</div>
                                                        <InputSearchKid  archiwalne='0' mainView={props.mainView}  userData={props.userData} value={row.fraza} err={errTab}  valChange={valChangeListener} goNext={goNextNew} kidSelected={kidSelected} name="fraza" placeholder={"Imię, nazwisko, fraza"} className=' w200 ' req='1' firstUp="1" />
                                                    </div>

                                        </div>

                            </form>        

            </div>
        }


        if(tabNieobecnosci == null )
        {                     
            return <div>
                ..
            </div>
        }

        if(tabGodziny == null )
            {                     
                return <div>
                    .......
                </div>
            }

        if(tabNadGodziny == null )
            {                     
                    return <div>
                        .............
                    </div>
            }            

        if(tabKalendar == null )
        {                     
             return <div>
                            .............
                        </div>
        }          

        if(tabWejsciaWyjscia  == null)
        {
            return <div>
                ..............
            </div>
        }

        if(tabStawki == null)
        {
            return <div>....</div>
        }



        const onChangeXTime = (hm, param1, param2, param3, param4) =>  {
              //param1 = 'YYYY-mm-dd'
              // param2 = 'I // O
              //param3,  id -- p_rejestr_id , lub puste..


              console.log("XTime ", hm, param1, param2, param3, param4);


              props.mainView.setProgress(-2);
      
             
              var req = {
                  p_dziecko_id: row.p_dziecko_id,
                  p_rejestr_id: param3,
                  dzien: param1,
                  hm: hm,   
                  operacja: param2,         
              };
      
      
              fetch( Config.url + '/rest_v1_kids,inout_update', {
                  method: 'POST', 
                  body: JSON.stringify(req), 
                  headers: {
                      'Content-Type': 'application/json',                    
                      'X-Api-Key': props.userData.apiKey,
                      '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                      '_p_dziecko_id_': props.userData.p_dziecko_id,
                      '_sec_key_': Config.genXKey() ,
                  }
               })
               .then(res => res.json() )
               .then(res => { 
      
                          props.mainView.setProgress(-1);        
                          if(res._sys_ == undefined)
                          {
                              props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                          }else
                          if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                          {
                              props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                          }else    
                          {
                             getAll(row.p_dziecko_id);
                           //   props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                          }
               } )
               .catch(err => {          
                          props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                          props.mainView.setProgress(-1);
               });

        }


        if(goAllRefresh == 1)
        {
            setGoAllRefresh(0);
            getAll();
        }




        var sumOB = [];
        var sumNB = [];
        var sumPO = [];


        for(var r=0; r<tabNieobecnosci.length; r++)
            {
                for(var d=0; d < tabNieobecnosci[r].dni.length; d++ )
                    {
                        sumOB.push(  {  dzien: tabNieobecnosci[r].dni[d].dzien, ilosc: 0  }  );                     
                        sumNB.push(  {  dzien: tabNieobecnosci[r].dni[d].dzien, ilosc: 0  }  ); 
                        sumPO.push(  {  dzien: tabNieobecnosci[r].dni[d].dzien, ilosc: 0  }  ); 
                    }    
                    break;      
            }
    
    
            for(var r=0; r<tabNieobecnosci.length; r++)
                {
                    for(var d=0; d < tabNieobecnosci[r].dni.length; d++ )
                        {
    
                            var xOB = 0;
                            var xNB = 0;
                            var xPO = 0;
    
                                if( tabNieobecnosci[r].dni[d].nb == '1' )
                                {
                                    xNB = 1;
    
                                    if( tabNieobecnosci[r].dni[d].po_czasie == '1' ){
                                        xPO = 1;
                                    }
    
                                }else
                                {
                                    xOB = 1;
                                }
    
                            if(xOB > 0)    
                                {
                                    for(var xt =0; xt<sumOB.length; xt++)
                                        {
                                            if(sumOB[xt].dzien == tabNieobecnosci[r].dni[d].dzien )
                                                {
                                                    sumOB[xt].ilosc++;   
                                                    
                                                }
                                        }
                                }
    
                            if(xNB > 0)    
                                    {
                                        for(var xt =0; xt<sumNB.length; xt++)
                                            {
                                                if(sumNB[xt].dzien == tabNieobecnosci[r].dni[d].dzien )
                                                    {
                                                        sumNB[xt].ilosc++;   
                                                    }
                                            }
                                    }
    
                            if(xPO > 0)    
                                        {
                                            for(var xt =0; xt<sumPO.length; xt++)
                                                {
                                                    if(sumPO[xt].dzien == tabNieobecnosci[r].dni[d].dzien )
                                                        {
                                                            sumPO[xt].ilosc++;   
                                                        }
                                                }
                                        }
    
                        }    
                        
                }        

                

     

        //----------------------------------------------------------------------------        



        document.title = row.profil.imie + " " + row.profil.nazwisko;

        return <div className="view_content">

                    {
                        (props.head == undefined || props.head == true) &&
                        <Fragment>
                                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                                <h1>{row.profil.imie + " " + row.profil.nazwisko}</h1>
                        </Fragment>
                    }

               

                 
                    <div className="table_filter">

                                    <div className="filter_controll">   
                                            <label>Rok: </label>                             
                                            <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={row.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                                    </div> 

                                    <div className="filter_controll">   
                                            <label>Miesiąc: </label>                             
                                            <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={row.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                                    </div>
                    </div> 


                 

                    <div className="bg_center">

                      
                                            <table className="table" >


                                            <thead>
                                                <tr className="header">
                                                    <td className="td_left">LP</td>                                                                                                
                                                    <td>Stawka</td>         
                                                    <td> </td>  

                                                    {
                                                        tabNieobecnosci.map( (row, ix) => {

                                                            if(ix > 0) return null;

                                                            return (
                                                                row.dni.map( (dd, id) => {
                                                                    return (
                                                                        <td>{id+1}</td>
                                                                    )
                                                                } )
                                                            )
                                                        

                                                        } )
                                                    }

                                                    <td>NB</td>
                                                    <td>OB</td>
                                                    <td>Il.</td>
                                                    <td>St.</td>
                                                    <td className="td_right">Kw.</td>

                                                </tr>
                                            </thead>

                                            <tbody>

                                                    {
                                            

                                                        tabNieobecnosci.map( (row, ix) => {

                                                            var razemNB = 0;
                                                            var razemOB = 0;       
                                                            
                                                            var iloscRoz   = 0;
                                                            var razemKwota = 0;

                                                            return (
                                                                <tr className="row">
                                                                    <td className="gocenter td_left">{ix+1} </td>                                                                                                           
                                                                    <td>{row.stawka}  <sup class="quick_tip" title={"Umowa nr " + row.numer_umowy}>&nbsp;?&nbsp;</sup> </td>    
                                                                    <td><XDateFee userData={props.userData}  mainView={props.mainView} p_umowa_oplaty_id={row.p_umowa_oplaty_id} onClose={getAll} /></td>

                                                                    {
                                                                        row.dni.map( (dd, id) => {

                                                                            var clsTD = " e_square_center ";
                                                                            var clsSquare = "e_ob_def";

                                                                            var infoDay = "Dzień: " + dd.dzien + "<br/><br/>";


                                                                            if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                            if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                            if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                            if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                            if( !(dd.w == '6' || dd.w == '0' || dd.wolne == '1' ) )
                                                                                {

                                                                                    if(dd.nb == '1')
                                                                                        {
                                                                                            razemNB = razemNB + 1;

                                                                                            clsSquare = "e_nb";

                                                                                            if(dd.po_czasie == '0')    
                                                                                                {
                                                                                                    //jest ok - nie liczymy

                                                                                                    infoDay = infoDay +  "Nieobecność zgłoszona w czasie<br/>";
                                                                                                }else 
                                                                                                {
                                                                                                    infoDay = infoDay +  "Nieobecność zgłoszona po czasie<br/>";

                                                                                                    clsSquare = "e_nbpc";

                                                                                                    iloscRoz = iloscRoz + 1;
                                                                                                    razemKwota = parseFloat(razemKwota) + parseFloat(row.kwota_netto);
                                                                                                }
                                                                                        }else
                                                                                        {
                                                                                            razemOB = razemOB + 1;

                                                                                            iloscRoz = iloscRoz + 1;
                                                                                            razemKwota = parseFloat(razemKwota) + parseFloat(row.kwota_netto);
                                                                                        }

                                                                                        if(dd.aktywna == '0')
                                                                                            {
                                                                                                clsSquare = "e_black";
                                                                                            }

                                                                                }
                                                                        
                                                                            if( (dd.w == '6' || dd.w == '0' || dd.wolne == '1'   ) )    
                                                                                {
                                                                                    return (
                                                                                        <td className={clsTD}>
                                                                                                                                                                            
                                                                                        </td>
                                                                                    )
                                                                                }                                                                           

                                                                            if(dd.aktywna == '0')    
                                                                                {
                                                                                    infoDay = 'Stawka nie obowiązuje w ten dzień';
                                                                                    return (
                                                                                        <td className={clsTD}  >
                                                                                            <span className={"e_squere " + clsSquare } status={dd.status}   dzien={dd.dzien} p_typy_oplat_id={row.p_typy_oplat_id}  p_dziecko_id={dd.p_dziecko_id}   >
                                                                                                <span className="info_day shadowx" dangerouslySetInnerHTML={{__html: infoDay}}   >
                                                                                                    
                                                                                                </span>
                                                                                            </span>                                                                                   
                                                                                        </td>
                                                                                    )
                                                                                }

                                                                            infoDay = row.imie+" " + row.nazwisko + "<br/>" +  infoDay +  "<br/>"
                                                                            for(var mx=0; mx<dd.h.length; mx++)   
                                                                                {
                                                                                    infoDay = infoDay +  dd.h[mx].data + " " + dd.h[mx].imie + " " + dd.h[mx].nazwisko + "<br/>"
                                                                                }


                                                                            return (
                                                                                <td className={clsTD}  >
                                                                                    <span className={"e_squere txtcloud " + clsSquare } status={dd.status}   dzien={dd.dzien} p_typy_oplat_id={row.p_typy_oplat_id}  p_dziecko_id={row.p_dziecko_id} onClick={zmienStatus}  >
                                                                                        <span className="info_content">
                                                                                        <span className="info_cloud shadowx" dangerouslySetInnerHTML={{__html: infoDay}}   >                                                                                                  
                                                                                        </span>
                                                                                        </span>                                                                                        
                                                                                    </span>                                                                                   
                                                                                </td>
                                                                            )
                                                                        } )

                                                                    
                                                                    
                                                                    }

                                                                    <td className="gocenter e_nb_txt" >{razemNB}</td>
                                                                    <td className="gocenter">{razemOB}</td>

                                                                    <td className="goright gobold">{(parseFloat(iloscRoz).toFixed(2)).replace(".",",")}</td>   
                                                                    <td className="goright gobold">{(parseFloat(row.kwota_netto).toFixed(2)).replace(".",",")}</td>   
                                                                    <td className="goright gobold">{ (parseFloat(razemKwota).toFixed(2)).replace(".",",")}</td>

                                                                </tr>
                                                            )

                                                        } )
                                                    }


                                                            <tr className="row">
                                                                    <td className="gocenter"> &nbsp; </td>                                                  
                                                                    <td> &nbsp;</td>  
                                                                    <td className="gobold"> Obecnych </td>  

                                                                    {
                                                                        sumOB.map( (item, iKey) =>{
                                                                                    return (
                                                                                        <td>{item.ilosc}</td>
                                                                                    )
                                                                        }    )

                                                                    }

                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                            </tr>

                                                            
                                                            <tr className="row">
                                                                    <td className="gocenter"> &nbsp; </td>                                                  
                                                                    <td> &nbsp;</td>  
                                                                    <td  className="gobold e_nb_txt"> Nieobecnych </td>  

                                                                    {
                                                                        sumNB.map( (item, iKey) =>{
                                                                                    return (
                                                                                        <td className="e_nb_txt">{item.ilosc}</td>
                                                                                    )
                                                                        }    )

                                                                    }

                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                            </tr>

                                                            <tr className="row">
                                                                    <td className="gocenter"> &nbsp; </td>                                                  
                                                                    <td> &nbsp;</td>  
                                                                    <td className="e_nbpc_txt"> Nieobecnych (Po czasie) </td>  

                                                                    {
                                                                        sumPO.map( (item, iKey) =>{
                                                                                    return (
                                                                                        <td className="e_nbpc_txt">{item.ilosc}</td>
                                                                                    )
                                                                        }    )

                                                                    }

                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                                    <td> &nbsp;</td>  
                                                            </tr>

                                            </tbody>

                                            </table>

                    </div>






        



                    <div className="bg_center">

                                <table className="table">
                                    <thead>
                                        <tr className="header">
                                            <td className="td_left"></td>
                                            <td></td>
                                            {
                                                tabKalendar.map( (calDay, inx) => {

                                                    if(inx >15) return null;

                                                    return <td>
                                                        {calDay.d}
                                                    </td>

                                                } )

                                            }
                                        </tr>
                                    </thead>

                                    <tbody>

                                         <tr className="row">
                                            <td>Przybycie</td>
                                            <td>-</td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx >15) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";

                                                        var tdContent =   <XTime title={ calDay.dzien} hour={ "00" } minute={ "00" }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3='-1' param4='' /> 

                                                        for(var io=0; io < tabWejsciaWyjscia.length; io++)
                                                        {
                                                            if(tabWejsciaWyjscia[io].dzien == calDay.dzien && tabWejsciaWyjscia[io].operacja == "I" )
                                                            {
                                                                tdContent =  <XTime title={ calDay.dzien} hour={ tabWejsciaWyjscia[io].h } minute={ tabWejsciaWyjscia[io].i }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3={ tabWejsciaWyjscia[io].id} param4='' />
                                                                break;
                                                            }
                                                        }

                                                        return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                    } )

                                                }
                                        </tr> 


                                        
                                        <tr className="row">
                                            <td>Wyjście</td>
                                            <td>-</td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx >15) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";


                                                        var tdContent =   <XTime title={ calDay.dzien} hour={ "00" } minute={ "00" }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "O" }  param3='-1' param4='' /> 

                                                        for(var io=0; io < tabWejsciaWyjscia.length; io++)
                                                        {
                                                            if(tabWejsciaWyjscia[io].dzien == calDay.dzien && tabWejsciaWyjscia[io].operacja == "O" )
                                                            {
                                                                tdContent =  <XTime title={ calDay.dzien} hour={ tabWejsciaWyjscia[io].h } minute={ tabWejsciaWyjscia[io].i }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3={tabWejsciaWyjscia[io].id} param4='' />
                                                                break;
                                                            }
                                                        }

                                                        return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                    } )

                                                }
                                        </tr> 

                                        <tr className="row">
                                            <td>Godziny (faktyczne)</td>
                                            <td>-</td>
                                            {
                                                  tabKalendar.map( (calDay, inx) => {

                                                        if(inx >15) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";

                                                        var tdContent = <span>--:--</span>;



                                                        for(var io=0; io < tabGodziny.length; io++)
                                                            {
                                                                if(tabGodziny[io].dzien == calDay.dzien  )
                                                                {
                                                                    tdContent =  <span>{tabGodziny[io].faktyczne_hm}</span>
                                                                    break;
                                                                }
                                                            }


                                                            return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                  } )
                                            }
                                        </tr>    


                                        <tr className="row">
                                            <td>Godziny (płatne)</td>
                                            <td>-</td>
                                            {
                                                  tabKalendar.map( (calDay, inx) => {

                                                        if(inx >15) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";


                                                        var tdContent = <span>--:--</span>;



                                                        for(var io=0; io < tabGodziny.length; io++)
                                                            {
                                                                if(tabGodziny[io].dzien == calDay.dzien  )
                                                                {
                                                                    tdContent =  <span>{tabGodziny[io].platne_hm}</span>
                                                                    break;
                                                                }
                                                            }


                                                            return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                  } )
                                            }
                                        </tr>     


                                        
                                        <tr className="row">
                                            <td>Nadgodziny</td>
                                            <td>-</td>
                                            {
                                                  tabKalendar.map( (calDay, inx) => {

                                                        if(inx >15) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";


                                                        var tdContent = <span>--:--</span>;



                                                        for(var io=0; io < tabNadGodziny.length; io++)
                                                            {
                                                                if(tabNadGodziny[io].dzien == calDay.dzien  )
                                                                {
                                                                    tdContent =  <span>{tabNadGodziny[io].faktyczne_hm}</span>
                                                                    break;
                                                                }
                                                            }


                                                            return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                  } )
                                            }
                                        </tr> 


                                        {
                                            tabStawki.map( (stawka, stInx) => {


    
                                                    if(stawka.umowa_od == null || stawka.umowa_od == undefined) stawka.umowa_od = " -- ";
                                                    if(stawka.umowa_do == null || stawka.umowa_do == undefined) stawka.umowa_do = " -- ";
                                                    var info = "Umowa nr " + stawka.numer_umowy + " (umowa od: "+stawka.umowa_od+" - "+stawka.umowa_do+" )";

                                                    if(stawka.sposob_naliczania_godzin == 'r')
                                                    {
                                                        info = info + ", za każdą rozpoczętą godzinę";
                                                    }

                                                    if(stawka.sposob_naliczania_godzin == '0')
                                                        {
                                                            info = info + ", naliczanie proporcjonalne";
                                                        }

                                                     info = info + ", stawka: " + stawka.kwota_netto + " zł ";   


                                                    return <tr className="row">

                                                               <td>{stawka.nazwa} [kwota] <sup class="quick_tip" title={info}>&nbsp;?&nbsp;</sup> </td>
                                                               <td className="gocenter"><XDateFee userData={props.userData}  mainView={props.mainView} p_umowa_oplaty_id={stawka.p_umowa_oplaty_id} onClose={getAll} /></td>

                                                               {
                                                                    tabKalendar.map( (calDay, inx) => {

                                                                            if(inx >15) return null;

                                                                            var colCss = "";

                                                                            if(calDay.w == 6) colCss = "e_squere_sb";
                                                                            if(calDay.w == 0) colCss = "e_squere_nd";


                                                                            var tdContent = <span>__.__</span>;

                                                                            var titleTime = "";

                                                                            var aktywna = "0";

                                                                            for(var io=0; io < stawka.dni.length; io++)
                                                                                {
                                                                                    if(stawka.dni[io].dzien == calDay.dzien  )
                                                                                    {
                                                                                        tdContent =   <FormatDecimal value={stawka.dni[io].kwota}/>  
                                                                                        titleTime=  stawka.dni[io].info;

                                                                                        aktywna =  stawka.dni[io].aktywna

                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if(aktywna == "0") colCss = colCss + " e_black " ;


                                                                                return <td className={ "gocenter " + colCss} title={ titleTime }>
                                                                                {tdContent}
                                                                            </td>

                                                                    } )
                                                                }

                                                    </tr>

                                            } )

                                        }


                                    </tbody>

                                </table>

                    </div>






            

                        <div className="bg_center">

                                    <table className="table">
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left"></td>
                                                <td></td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx <=15) return null;

                                                        return <td>
                                                            {calDay.d}
                                                        </td>

                                                    } )

                                                }
                                            </tr>
                                        </thead>

                                        <tbody>

                                            <tr className="row">
                                                <td>Przybycie</td>
                                                <td>-</td>
                                                    {
                                                        tabKalendar.map( (calDay, inx) => {

                                                            if(inx <=15) return null;

                                                            var colCss = "";

                                                            if(calDay.w == 6) colCss = "e_squere_sb";
                                                            if(calDay.w == 0) colCss = "e_squere_nd";

                                                            var tdContent =   <XTime title={ calDay.dzien} hour={ "00" } minute={ "00" }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3='-1' param4='' /> 

                                                            for(var io=0; io < tabWejsciaWyjscia.length; io++)
                                                            {
                                                                if(tabWejsciaWyjscia[io].dzien == calDay.dzien && tabWejsciaWyjscia[io].operacja == "I" )
                                                                {
                                                                    tdContent =  <XTime title={ calDay.dzien} hour={ tabWejsciaWyjscia[io].h } minute={ tabWejsciaWyjscia[io].i }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3={ tabWejsciaWyjscia[io].id} param4='' />
                                                                    break;
                                                                }
                                                            }

                                                            return <td className={ "gocenter " + colCss}>
                                                                {tdContent}
                                                            </td>

                                                        } )

                                                    }
                                            </tr> 


                                            
                                            <tr className="row">
                                                <td>Wyjście</td>
                                                <td>-</td>
                                                    {
                                                        tabKalendar.map( (calDay, inx) => {

                                                            if(inx <=15) return null;

                                                            var colCss = "";

                                                            if(calDay.w == 6) colCss = "e_squere_sb";
                                                            if(calDay.w == 0) colCss = "e_squere_nd";


                                                            var tdContent =   <XTime title={ calDay.dzien} hour={ "00" } minute={ "00" }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "O" }  param3='-1' param4='' /> 

                                                            for(var io=0; io < tabWejsciaWyjscia.length; io++)
                                                            {
                                                                if(tabWejsciaWyjscia[io].dzien == calDay.dzien && tabWejsciaWyjscia[io].operacja == "O" )
                                                                {
                                                                    tdContent =  <XTime title={ calDay.dzien} hour={ tabWejsciaWyjscia[io].h } minute={ tabWejsciaWyjscia[io].i }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3={tabWejsciaWyjscia[io].id} param4='' />
                                                                    break;
                                                                }
                                                            }

                                                            return <td className={ "gocenter " + colCss}>
                                                                {tdContent}
                                                            </td>

                                                        } )

                                                    }
                                            </tr> 

                                            <tr className="row">
                                                <td>Godziny (faktyczne)</td>
                                                <td>-</td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx <=15) return null;

                                                            var colCss = "";

                                                            if(calDay.w == 6) colCss = "e_squere_sb";
                                                            if(calDay.w == 0) colCss = "e_squere_nd";

                                                            var tdContent = <span>--:--</span>;



                                                            for(var io=0; io < tabGodziny.length; io++)
                                                                {
                                                                    if(tabGodziny[io].dzien == calDay.dzien  )
                                                                    {
                                                                        tdContent =  <span>{tabGodziny[io].faktyczne_hm}</span>
                                                                        break;
                                                                    }
                                                                }


                                                                return <td className={ "gocenter " + colCss}>
                                                                {tdContent}
                                                            </td>

                                                    } )
                                                }
                                            </tr>    


                                            <tr className="row">
                                                <td>Godziny (płatne)</td>
                                                <td>-</td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx <=15) return null;

                                                            var colCss = "";

                                                            if(calDay.w == 6) colCss = "e_squere_sb";
                                                            if(calDay.w == 0) colCss = "e_squere_nd";


                                                            var tdContent = <span>--:--</span>;



                                                            for(var io=0; io < tabGodziny.length; io++)
                                                                {
                                                                    if(tabGodziny[io].dzien == calDay.dzien  )
                                                                    {
                                                                        tdContent =  <span>{tabGodziny[io].platne_hm}</span>
                                                                        break;
                                                                    }
                                                                }


                                                                return <td className={ "gocenter " + colCss}>
                                                                {tdContent}
                                                            </td>

                                                    } )
                                                }
                                            </tr>     


                                            
                                            <tr className="row">
                                                <td>Nadgodziny</td>
                                                <td>-</td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx <=15) return null;

                                                            var colCss = "";

                                                            if(calDay.w == 6) colCss = "e_squere_sb";
                                                            if(calDay.w == 0) colCss = "e_squere_nd";


                                                            var tdContent = <span>--:--</span>;



                                                            for(var io=0; io < tabNadGodziny.length; io++)
                                                                {
                                                                    if(tabNadGodziny[io].dzien == calDay.dzien  )
                                                                    {
                                                                        tdContent =  <span>{tabNadGodziny[io].faktyczne_hm}</span>
                                                                        break;
                                                                    }
                                                                }


                                                                return <td className={ "gocenter " + colCss}>
                                                                {tdContent}
                                                            </td>

                                                    } )
                                                }
                                            </tr> 


                                            {
                                                tabStawki.map( (stawka, stInx) => {



                                                        if(stawka.umowa_od == null || stawka.umowa_od == undefined) stawka.umowa_od = " -- ";
                                                        if(stawka.umowa_do == null || stawka.umowa_do == undefined) stawka.umowa_do = " -- ";
                                                        var info = "Umowa nr " + stawka.numer_umowy + " (umowa od: "+stawka.umowa_od+" - "+stawka.umowa_do+" )";

                                                        if(stawka.sposob_naliczania_godzin == 'r')
                                                        {
                                                            info = info + ", za każdą rozpoczętą godzinę";
                                                        }

                                                        if(stawka.sposob_naliczania_godzin == '0')
                                                            {
                                                                info = info + ", naliczanie proporcjonalne";
                                                            }

                                                        info = info + ", stawka: " + stawka.kwota_netto + " zł ";   


                                                        return <tr className="row">

                                                                <td>{stawka.nazwa} [kwota] <sup class="quick_tip" title={info}>&nbsp;?&nbsp;</sup> </td>
                                                                <td className="gocenter"><XDateFee userData={props.userData}  mainView={props.mainView} p_umowa_oplaty_id={stawka.p_umowa_oplaty_id} onClose={getAll} /></td>

                                                                {
                                                                        tabKalendar.map( (calDay, inx) => {

                                                                            if(inx <=15) return null;

                                                                                var colCss = "";

                                                                                if(calDay.w == 6) colCss = "e_squere_sb";
                                                                                if(calDay.w == 0) colCss = "e_squere_nd";


                                                                                var tdContent = <span>__.__</span>;

                                                                                var titleTime = "";

                                                                                var aktywna = 0;

                                                                                for(var io=0; io < stawka.dni.length; io++)
                                                                                    {
                                                                                        if(stawka.dni[io].dzien == calDay.dzien  )
                                                                                        {
                                                                                            tdContent =   <FormatDecimal value={stawka.dni[io].kwota}/>  
                                                                                            titleTime=  stawka.dni[io].info;

                                                                                            aktywna =  stawka.dni[io].aktywna

                                                                                            break;
                                                                                        }
                                                                                    }

                                                                                    if(aktywna == 0) colCss = colCss + " e_black " ;


                                                                                    return <td className={ "gocenter " + colCss} title={ titleTime }>
                                                                                    {tdContent}
                                                                                </td>

                                                                        } )
                                                                    }

                                                        </tr>

                                                } )

                                            }


                                        </tbody>

                                    </table>

                        </div>




            

                        <div className="bg_center">

                            <table className="table">
                                          <thead>
                                                <tr className="header">
                                                    <td className="td_left">LP</td>
                                                    <td>Nazwa stawki</td>
                                                    <td>Ilość rozpoczętych godzin / Suma minut zamieniona na godziny w postaci dziesiętnej</td>
                                                    <td className="td_right">Kwota</td>
                                                </tr>
                                         </thead>      
                                         <tbody>
                                            {
                                                tabStawki.map( (stawka, inx) => {

                                                    var kwota = 0.00;
                                                    var iloscGodz = 0;  //gdy do pelnych godzin..
                                                    var iloscProp = 0;  //gdy proporconalnie..

                                                    for(var k=0; k<stawka.dni.length; k++)
                                                    {
                                                        kwota =   parseFloat( stawka.dni[k].kwota ) + parseFloat(kwota);

                                                        iloscGodz =   parseFloat( stawka.dni[k].ilosc_godzin ) + parseFloat(iloscGodz);
                                                        iloscProp =   parseFloat( stawka.dni[k].ilosc_prop ) + parseFloat(iloscProp);
                                                    }

                                                    return <tr className="row">
                                                            <td className="gocenter">{inx+1}</td>
                                                            <td>{stawka.nazwa}</td>
                                                            <td className="gocenter">{iloscGodz} / {iloscProp}</td>
                                                            <td className="goright"><FormatDecimal  value={kwota} /></td>
                                                    </tr>   
                                                } )
                                            }
                                         </tbody>
                            </table>
                        </div>



            </div>




}

export default Start;